import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Variant, VariantType } from '~shared/models/product-card/product-variant.model';
import { CombineLatestOperator } from 'rxjs/internal-compatibility';
import { PDPNavigatorService } from '~shared/modules/pdp-navigator/pdp-navigator.service';
import { $e } from 'codelyzer/angular/styles/chars';
import { ProductCardImageUtil } from '~shared/modules/product-card/utils/product-card-image.util';

@Component({
  selector: 'app-variants-selector',
  templateUrl: './variants-selector.component.html',
  styleUrls: ['./variants-selector.component.scss'],
})
export class VariantsSelectorComponent implements OnInit {
  @Input()
  variants: Variant;
  @Input()
  baseProductImage: string;
  @Input()
  isMobile: boolean;
  @Input()
  baseProductId: string;
  @Input()
  isSimilarProductRecommendation: boolean;
  @Output() bulletClicked: EventEmitter<string> = new EventEmitter<string>();
  @Input()
  variantsSelectorHeightconfig: {
    hasColors: boolean;
    hasSizes: boolean;
  };
  @Input() carouselProductCard: boolean;

  colors: VariantType;
  hasSizes: boolean;
  baseProductLink: string;

  constructor(private pdpNavigatorService: PDPNavigatorService) {}

  ngOnInit(): void {
    this.colors = this.variants?.types?.color;
    if (!!this.variants) {
      const variantTypes: [string, VariantType][] = Object.entries(this.variants?.types) || [];
      const notColorVariants: [string, VariantType][] = variantTypes?.filter(
        (variant: [string, VariantType]) => variant[0] !== 'color'
      );
      this.hasSizes = notColorVariants && !!notColorVariants?.length;
    }

    this.baseProductLink = this.getPdpLink(this.baseProductId);
  }

  getPdpLink(variantId: string): string {
    return this.pdpNavigatorService.getPdpLink(variantId);
  }

  onBaseProductBulletClick(event: Event) {
    event.stopPropagation();
    this.bulletClicked.emit(this.baseProductId);
    this.pdpNavigatorService.navigateToPDP(
      event,
      this.baseProductId,
      this.isSimilarProductRecommendation ? '?fromSimilarProducts=1' : ''
    );
  }

  onMoreSizesAvailableLinkClick(event: Event) {
    event.stopPropagation();
    this.pdpNavigatorService.navigateToPDP(
      event,
      this.baseProductId,
      this.isSimilarProductRecommendation ? '?fromSimilarProducts=1' : ''
    );
  }

  onBulletClick(event: Event, variantId: string) {
    event.stopPropagation();
    this.bulletClicked.emit(variantId);
    this.pdpNavigatorService.navigateToPDP(
      event,
      variantId,
      this.isSimilarProductRecommendation ? '?fromSimilarProducts=1' : ''
    );
  }

  protected readonly $e = $e;
  getSrcSet(imageUrl: string): string {
    return ProductCardImageUtil.getSourceSet(imageUrl, true);
  }
}
